import { useTranslation } from "react-i18next";
import FinishedIcon from "../widgets/components/FinishedIcon";
import P from "../../components/Paragraph";
import classNames from "classnames";
import styles from "./messageCard.module.css";

const ScoreCard = ({ score }) => {
  const { t } = useTranslation();
  if (score?.status === "processing") {
    return null;
  }
  if (score?.scores == null) {
    return null;
  }

  return (
    <div className={classNames(styles.messageLine, styles.systemMessage)}>
      <div
        className={classNames(styles.messageCard, styles.scoreCard)}
        style={{ whiteSpace: "pre-wrap" }}
      >
        <FinishedIcon size={40} />
        {score?.scores?.map((scoreItem) => (
          <div key={scoreItem.topic} className={styles.scoreContainer}>
            <P style={{ textAlign: "center" }}>
              <span className={styles.topic}>{scoreItem.topic}</span>
            </P>
            <P style={{ textAlign: "center" }}>
              {t("chat.pointsEarned")}{" "}
              <span className={styles.delta}>
                {Math.round(scoreItem.delta * 100) / 100}
              </span>
            </P>
          </div>
        ))}
        {score?.messages?.map((messageItem) => (
          <div key={messageItem.topic} className={styles.scoreContainer}>
            <P style={{ textAlign: "center" }}>
              {messageItem.text}{" "}
              <span className={styles.topic}>{messageItem.topic}</span>
            </P>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScoreCard;
